import styled from 'styled-components';

const LeftBox = styled.div`
  padding: 40px;
`;

export default LeftBox;
